export const DEFAULT_STEP = 1;

export const TEST_ID = 'stepperField';
